import { useEffect, useRef, useState } from "react";
import { Box, Button, Menu, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";

import TextField from "../TextField";

import { createProductReplenish } from "../../services/apiV2";
import { IProductHistory } from "../../features/productAnalyzer/productAnalyzer.types";

interface IReplenishMenuProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  meta: {
    asin: string;
    salePrice: number;
    costPrice: number;
  };
  onClose: () => void;
  onReplenish?: (data: IProductHistory) => void;
}

export const ReplenishMenu: React.FC<IReplenishMenuProps> = ({
  meta,
  open,
  anchorEl,
  onClose,
  onReplenish,
}) => {
  const [quantity, setQuantity] = useState<number>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const textRef = useRef<HTMLInputElement | null>(null);

  const handleQuantityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuantity(Number(event.target.value));
  };

  const handleAdd = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (quantity) {
      setIsLoading(true);
      createProductReplenish({ quantity, ...meta })
        .then((response) => {
          setIsLoading(false);
          enqueueSnackbar("Successfully added replenished quantity.", {
            variant: "success",
          });
          onReplenish?.({ ...response.data, type: "replenish" });
          // onReplenish?.({
          //   quantity,
          //   ...meta,
          //   id: String(Math.random()),
          //   createdAt: Date.now(),
          //   type: "replenish",
          // });
          onClose();
          setQuantity(undefined);
        })
        .catch((error) => {
          console.error(error);
          enqueueSnackbar("Something went wrong! Please try again later.", {
            variant: "error",
          });
          onClose();
        });
    }
  };

  useEffect(() => {
    if (open && textRef.current) {
      textRef.current.focus();
    }
  }, [open, textRef.current]);

  return (
    <Menu
      id="replenish-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      slotProps={{
        list: {
          "aria-labelledby": "replenish-button",
        },
      }}
    >
      <Box
        width={"120px"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        gap={"5px"}
      >
        <Typography
          variant="body2"
          sx={{
            fontFamily: "Inter",
            fontWeight: 600,
            fontSize: 12,
          }}
        >
          Replenished QTY
        </Typography>
        <TextField
          type="number"
          ref={textRef}
          value={quantity}
          onChange={handleQuantityChange}
          textAlign="center"
          sx={{ width: "100px" }}
          autoFocus
          slotProps={{
            input: {
              min: 0,
            },
          }}
        />
        <Button
          variant="contained"
          size="small"
          onClick={handleAdd}
          disabled={!quantity}
          loading={isLoading}
          sx={{ width: "100px" }}
        >
          Add
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={onClose}
          sx={{ width: "100px" }}
        >
          Cancel
        </Button>

        {/* {!!data.length && (
          <Box
            display={"grid"}
            gridTemplateColumns={" 2fr 3fr"}
            sx={{
              fontSize: "11px",
              color: "#000000CC",
              width: "100%",
              maxHeight: "200px",
              textAlign: "center",
              alignItems: "center",
              marginBottom: "-8px",
            }}
          >
            <Box
              sx={{
                height: "100%",
                borderRight: "1px solid #181D1F26",
                fontWeight: 600,
                lineHeight: "20px",
                borderBottom: "1px solid #181D1F26",
                background: "#181D1F0D",
              }}
            >
              Units
            </Box>
            <Box
              sx={{
                height: "100%",
                fontWeight: 600,
                lineHeight: "20px",
                borderBottom: "1px solid #181D1F26",
                background: "#181D1F0D",
              }}
            >
              Date
            </Box>
            {data.map((row, index) => (
              <>
                <Box
                  height={"100%"}
                  borderRight={"1px solid #181D1F26"}
                  borderBottom={
                    index !== data.length - 1 ? "1px solid #181D1F26" : "none"
                  }
                  textAlign={"center"}
                  lineHeight={"20px"}
                >
                  {formatNumber(row.quantity)}
                </Box>
                <Box
                  textAlign={"center"}
                  lineHeight={"20px"}
                  borderBottom={
                    index !== data.length - 1 ? "1px solid #181D1F26" : "none"
                  }
                >
                  {moment(row.createdAt).format("MM/DD/YYYY")}
                </Box>
              </>
            ))}
          </Box>
        )} */}
      </Box>
    </Menu>
  );
};

export default ReplenishMenu;
